import { render } from "./ProAlert.vue?vue&type=template&id=b786e03e"
import script from "./ProAlert.vue?vue&type=script&lang=js"
export * from "./ProAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/ProAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b786e03e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b786e03e', __exports__)) {
    api.reload('b786e03e', __exports__)
  }
  
  module.hot.accept("./ProAlert.vue?vue&type=template&id=b786e03e", () => {
    api.rerender('b786e03e', render)
  })

}


export default __exports__